import React, { FunctionComponent, useEffect } from 'react';
import { Enums } from '@letsdothis/tracking';
import {
  getCLS,
  getFID,
  getLCP,
  getTTFB,
  getFCP,
  Metric,
  ReportHandler,
} from 'web-vitals';

import { useTrackingLibrary } from '@hooks/useTrackingLibrary';

interface Props {
  children: React.ReactNode;
}

const WebVitalsTracker: FunctionComponent<Props> = ({ children }) => {
  const tracking = useTrackingLibrary();

  const trackMetric = (
    type: Enums.PerformanceMetricNameEnum,
  ): ReportHandler => ({ id, value, delta, isFinal }: Metric): void => {
    tracking.track(Enums.EventType.PerformanceMetric, {
      name: type,
      value,
      delta,
      id,
      isFinal,
    });
  };

  useEffect(() => {
    getCLS(trackMetric(Enums.PerformanceMetricNameEnum.CumulativeLayoutShift));
    getFID(trackMetric(Enums.PerformanceMetricNameEnum.FirstInputDelay));
    getTTFB(trackMetric(Enums.PerformanceMetricNameEnum.TimeToFirstByte));
    getFCP(trackMetric(Enums.PerformanceMetricNameEnum.FirstContentfulPaint));
    getLCP(
      trackMetric(Enums.PerformanceMetricNameEnum.LargestContentfulPaint),
      true,
    );
  }, []);

  return <>{children}</>;
};

export default WebVitalsTracker;
